/* global jQuery */
(function ($) {
  $(function () {
    var $root = $('.form-container');

    $root.on('change', 'input[type="checkbox"], input[type="radio"]', function () {
      var name   = this.name; // group by name
      var $group = $root.find('input[name="' + name + '"]');

      // If you want checkboxes to behave like radios (only one):
      if (this.type === 'checkbox') {
        $group.not(this).prop('checked', false);
      }

      // Update wrappers & labels for the whole group (SET, don’t blindly toggle)
      $group.each(function () {
        var isChecked = this.checked;
        var $input    = $(this);
        var $wrap     = $input.closest('.pretty-element');
        var $label    = $root.find('label[for="' + this.id + '"]');

        // reflect actual state
        $wrap.toggleClass('show', isChecked);
        $label.toggleClass('checked', isChecked);
      });
    });
  });
})(jQuery);
